import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {withRouter} from 'react-router-dom';
import ReactHighcharts from 'react-highcharts';
import * as AdminActions from '../../store/actions/adminActions';

class KPI extends Component {
    componentDidMount(){
        this.props.getKPI('users', 1, this.props.match.params.courseId, this.props.user.user.id,  this.props.user.id);
        //this.props.getKPI('users', '', 1, this.props.user.id);

        if (this.props.match.params.courseId) {
            this.init();
        }
        //this.props.getViewCounts(this.props.user.id);
    }

    componentDidUpdate(props) {
        if (props.match.params.courseId !== this.props.match.params.courseId) {
            this.init();
        }
    }

    init = () => {
        this.props.getKpiStats(this.props.match.params.courseId, this.props.user.id);
    }

    renderTabs = () => {
        let courseIds = [];
        if(this.props.match.params.courseId){
            courseIds = [this.props.match.params.courseId];
        }else{
            courseIds = this.props.adminCourses.map(c => c.id);
        }

        if(this.props.views){
            return this.props.views.map((v, i) => {
                return (
                    <li role="presentation" className={this.props.kpiView === v.view ? 'active' : ''}>
                        <a href="#TabUsers" onClick={e => {
                            e.preventDefault();
                            // console.log("loiading vide", v);
                            this.props.getKPI(v.view, 1, this.props.match.params.courseId, this.props.user.user.id,  this.props.user.id);
                        }} data-toggle="tab">
                            {v.name}
                            <p className="font-24 font-700 sm-bottom0">{v.view === 'videoTime' ? 
                                <span>
                                    {moment(moment.duration(this.props.kpiStats['videoTime'].current, "minutes")).format('hh:mm:ss')}
                                </span>
                            : this.props.kpiStats[v.view].current}</p>
                            <p className="text-green sm-bottom0">
                                {this.props.kpiStats[v.view].progress > -1 ? '+' : '-'}{this.props.kpiStats[v.view].progress}%</p>
                        </a>
                    </li>
                )
            })
        }else{
            return null
        }
    }
    
    render(){
        return (
            <li className="dd-item dd3-item" data-id="13">
                <div className="dd-handle dd3-handle"></div>
                <div className="dd3-content">
                    
                    <div className="panel customPanel">
                        <div className="panel-heading border-bottom panel-heading-with-subtext">
                            <h3 className="panel-title">Key Performance Indicators</h3>
                        </div>
                        <div className="panel-body no-padding">
                            <div className="custom-tabs">
                                <ul className="nav nav-tabs" role="tablist">
                                    {this.renderTabs()}
                                </ul>

                                
                                <div className="tab-content">
                                    <div className="tab-pane active" id="TabUsers">
                                        <div id="UsersGraph" >

                                            {this.props.charts[this.props.kpiView] ?
                                                <ReactHighcharts
                                                    config={this.props.charts[this.props.kpiView]}
                                                    isPureConfig={true}
                                                    neverReflow={true}
                                                    ref="chart"
                                                />
                                                :
                                                null
                                            }
                                        </div>
                                    </div>
                                    <div className="tab-pane" id="TabSessions">
                                        <div id="SessionsGraph" ></div>
                                    </div>
                                    <div className="tab-pane" id="TabVideoTime">
                                        <div id="VideoTimeGraph" ></div>
                                    </div>
                                    <div className="tab-pane" id="TabRevenue">
                                        <div id="RevenueGraph" ></div>
                                    </div>
                                    <div className="tab-pane" id="TabMessages">
                                        <div id="MessagesGraph" ></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="panel-footer">
                            <div className="w-200">
                                <div className="form-select-overlay ">
                                    <select value={this.props.kpiLength} onChange={e => {
                                        e.preventDefault();
                                        this.props.getKPI(this.props.kpiView, e.target.value, this.props.match.params.courseId, this.props.user.user.id,  this.props.user.id);
                                        //this.props.getKPI(this.props.kpiView, '', e.target.value, this.props.user.id);
                                    }} className="form-control" required="required">
                                        <option value={1}>Yesterday</option>
                                        <option value={2}>2 day</option>
                                        <option value={7}>1 Week</option>
                                        <option value={30}>1 Month</option>
                                        <option value={365}>1 Year</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getKPI: (view, length, courseId, userId, token) => {
        // console.log("V", view, length, courseId, userId, token);
        dispatch(AdminActions.getKPI(view, length, courseId, userId, token));
    },
    getViewCounts: (token) => {
        dispatch(AdminActions.getViewCounts(token));
    },
    getKpiStats: (courseId, token) => {
        dispatch(AdminActions.getKpiStats(courseId, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(KPI));


// WEBPACK FOOTER //
// ./src/components/AdminConsole/kpi.js